// helps checking for possible falsy values in InputNumber except 0
export const isEmptyValue = (value: string | number | undefined | null) =>
  value === '' || value === undefined || value === null
